import { Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
import { Content } from '../../../../../../lib/model/Content';
import { Tag } from '../../../../../../lib/model/Tag';
import { TypeBooks } from '../../../model/TypeBooks';
import { LooseBookForm } from '../LooseBookForm';
import { SelectTypeBooks } from '../SelectTypeBook';
import { SelectTags } from '../SelectTags';
import { SelectTagType } from './SelectTagType';
import { TagTypeWithColor } from './tag_type';
import { PeriodicTagsForm } from '../PeriodicTagsForm';
import { NewsTagForm } from '../NewsTagForm';
import { CodeTagForm } from '../CodeTagForm';
import { SelectTagsVidsSeries } from '../SelectTagsVidsSeries';
import { SelectTagsBooksSeries } from '../SelectTagsBooksSeries';
import { SelectTagsIaUser } from '../SelectTagsIaUser';
import { ForumSignatureTag } from '../ForumSignatureTag';

interface IProps {
	visible: boolean;
	close: () => void;
	on_change: (tags: Tag[]) => void;
	tag_type: TagTypeWithColor;
	on_select_tag_type: (tag_type: TagTypeWithColor) => void;
	tags: Tag[];
	periodics?: any[];
	contents?: Content[];
}

export const ContentSeriesModal: FC<IProps> = ({
	visible,
	close,
	on_change,
	tag_type,
	on_select_tag_type,
	tags,
	periodics,
	contents = [],
}) => {
	const [book_type, set_book_type] = useState<TypeBooks>(TypeBooks.SELECIONE);

	useEffect(() => {
		if (visible) {
			set_book_type(TypeBooks.SELECIONE);
		}
	}, [visible]);

	const has_forum_signature = tags.some((t) => t.id?.includes('forum-signature'));
	const blocked = has_forum_signature && tag_type?.value !== 'ia';

	return (
		<Modal
			{...{
				visible,
				closable: true,
				onCancel: close,
				centered: true,
				destroyOnClose: true,
				title: 'Seleção de Conteúdos',
				width: 800,
				footer: null,
			}}
		>
			<ForumSignatureTag
				{...{
					selected_contents: tags,
					tag_type,
					on_change,
					close,
				}}
			/>
			<SelectTagType {...{ on_select_tag_type, disabled: has_forum_signature }} />
			{tag_type.value && !blocked && (
				<>
					<h2 className='mt-2 mb-0'>
						{tag_type?.value === 'periodic' ? 'Tags de Revistas' : ''}
						{tag_type?.value === 'ia'
							? 'Insira o e-mail para ativar o módulo de IA para o usuário'
							: ''}
						{tag_type?.value === 'book' ? 'Selecione um item' : ''}
						{!['periodic', 'news', 'code', 'book', 'ia'].includes(tag_type?.value)
							? `Séries de ${tag_type.title}`
							: ''}
					</h2>
					{tag_type?.value === 'periodic' ? (
						<PeriodicTagsForm
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
							}}
						/>
					) : (
						<></>
					)}
					{tag_type?.value === 'news' ? (
						<NewsTagForm
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
							}}
						/>
					) : (
						<></>
					)}
					{tag_type?.value === 'code' ? (
						<CodeTagForm
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
							}}
						/>
					) : (
						<></>
					)}
					{tag_type?.value === 'book' ? (
						<>
							<SelectTypeBooks
								{...{
									value: book_type,
									on_change: (_field: any, value: TypeBooks) => set_book_type(value),
								}}
							/>
							{book_type === TypeBooks.LIVRO_AVULSO && (
								<LooseBookForm
									{...{
										selected_contents: tags,
										tag_type,
										on_change,
										close,
										contents,
									}}
								/>
							)}
							{book_type === TypeBooks.COLECAO && (
								<SelectTagsBooksSeries
									{...{
										selected_contents: tags,
										tag_type,
										on_change,
										close,
										periodics,
									}}
								/>
							)}
						</>
					) : (
						<></>
					)}
					{tag_type?.value === 'video' ? (
						<SelectTagsVidsSeries
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
								periodics,
							}}
						/>
					) : (
						<></>
					)}

					{!['periodic', 'news', 'code', 'book', 'video', 'ia'].includes(tag_type?.value) ? (
						<SelectTags
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
								periodics,
							}}
						/>
					) : (
						<></>
					)}
					{tag_type?.value === 'ia' ? (
						<SelectTagsIaUser
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
							}}
						/>
					) : (
						<></>
					)}
				</>
			)}
		</Modal>
	);
};
